var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"activity-result__stack-list__item",class:{ active: _vm.active, selected: _vm.selected }})
}
var staticRenderFns = []

export { render, staticRenderFns }